import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import apiClient from "../apiClient";
import {
  ASSIGN_RESOURCE,
  GROUP_CHILDREN_USERS,
  GROUP_USERS_LIST,
} from "../apiClient/apiEndpoints";
import {
  getPlaceholderName,
  modalName,
  removeDuplicatesByKey,
  removeMatchedDataUsingKey,
  toggleArrayByObject,
} from "../utils/general";
import { useModalContext } from "./context/ModalProvider";
import {
  GROUP_TAB_TYPE,
  TABS_TYPE_KEY,
  USER_LIMIT,
  USER_TAB_TYPE,
} from "../constant/constants";

const {
  SimCheckBox,
  SearchBar,
  TabNavigator,
  SimAccordion,
  SkeltonResourceManage,
} = UiComponents;
const { useUnoSelector } = UnoStoreHooks;

const ShareModal = () => {
  const configData = useUnoSelector((state) => state.config);
  const [assign, setAssign] = useState(false);
  const groupData = useSelector((state) => state.groupSlice);
  const userData = useUnoSelector((state) => state.user);
  const [search, setSearch] = useState("");
  const [usersList, setUsersList] = useState([]);
  const [applyToAllUser, setApplyToAllUser] = useState(false);
  const [activeTab, setActiveTab] = useState(USER_TAB_TYPE);
  const [loading, setLoading] = useState(false);
  const { modalState, openModal, closeModal } = useModalContext();
  const {
    params,
    selectedResource,
    handleResetSelectResource,
    message,
    allCheckboxTransferKeys,
    filter,
  } = modalState;
  let { uuid } = params;
  const [groupHierarchy, setAllGroupsHierarchy] = useState({
    list: [],
    hierarchy: [],
  });

  const [selectedUserGroup, setSelectedUserGroup] = useState({
    [USER_TAB_TYPE]: [],
    [GROUP_TAB_TYPE]: [],
  });

  const getUsersList = async () => {
    setLoading(true);
    try {
      let data = await apiClient.get(
        `${configData.config.UNO_URL}${GROUP_CHILDREN_USERS}/${userData.user.group.uuid}`,
        {
          params: {
            limit: USER_LIMIT,
            page: 1,
            search: search,
          },
        }
      );
      let filterList = data.filter((e) => e.uuid !== userData.user.uuid);
      setUsersList(filterList);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      getUsersList();
    }, 500);

    return () => clearTimeout(timer);
  }, [params, search]);

  useEffect(() => {
    setAllGroupsHierarchy({
      // list: groupData?.allChildren?.map(e => ({ value: e.uuid, label: e.name, avatar: e.avatar, type: "group" })) || [],
      list: groupData?.allChildren || [],
      hierarchy: groupData?.allHierarchy ? [groupData?.allHierarchy] : [],
    });
  }, [groupData]);

  const onUnAssign = () => {
    setAssign(true);
  };

  const handleCheckboxChange = (data, type) => {
    const { name, uuid: id, avatar, email, uid } = data;
    const newData =
      type === USER_TAB_TYPE
        ? { name, id, uid, avatar, email }
        : { name, id, avatar };
    setSelectedUserGroup((pre) => ({
      ...pre,
      [type]: toggleArrayByObject(pre[type], newData),
    }));
  };

  const handleResetData = () => {
    handleResetSelectResource();
    setSelectedUserGroup({
      [USER_TAB_TYPE]: [],
      [GROUP_TAB_TYPE]: [],
    });
  };

  const handleCancelModal = () => {
    closeModal();
    handleResetData();
  };

  const handleVerifyModalShow = async () => {
    try {
 
      let movingData = {};
      if (
        [
          ...selectedUserGroup[USER_TAB_TYPE],
          ...selectedUserGroup[GROUP_TAB_TYPE],
        ].length === 0
      )
        return;

      let bodyData = {
        applications: selectedResource.application.map((e) => e.id),
        resourceIds: selectedResource.module.map((e) => e.id),
        checkedBox: Object.keys(allCheckboxTransferKeys)
          .filter((e) => allCheckboxTransferKeys[e])
          .map((q) => TABS_TYPE_KEY[q]),
        users: selectedUserGroup[USER_TAB_TYPE].map((e) => e.id),
        groups: selectedUserGroup[GROUP_TAB_TYPE].map((e) => e.id),
        // applyToAllUser: applyToAllUser,
        filter,
      };

      let transferData = [
        ...selectedResource.application.map(({ name, avatar }) => ({
          name,
          avatar: avatar || null,
        })),
        ...selectedResource.module.map(({ name, avatar }) => ({
          name,
          avatar: avatar || null,
        })),
      ];

      movingData["transfer"] = {
        type: "user",
        data: transferData,
      };

      movingData["receiver"] = {
        type: "group",
        data: [
          ...selectedUserGroup[USER_TAB_TYPE],
          ...selectedUserGroup[GROUP_TAB_TYPE],
        ].map((item) => ({
          name: item.name,
          avatar: item.avatar || null,
        })),
      };

      openModal({
        modalName: modalName.SUCCESSFULLY_POPUP,
        message,
        transferring: true,
        movingData,
        modalSize: "lg",
      });
      await apiClient.post(
        `${configData.config.UNO_URL}${ASSIGN_RESOURCE}`,
        bodyData
      );
      setTimeout(() => {
        openModal({
          modalName: modalName.SUCCESSFULLY_POPUP,
          message: `Assigned successfully.`,
          transferring: false,
          movingData,
        });
        setTimeout(() => {
          handleCancelModal();
        }, 1500);
      }, 1500);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSelectAllUser = (e) => {
    const isChecked = e.target.checked;
    setSelectedUserGroup((pre) => ({
      ...pre,
      [USER_TAB_TYPE]: isChecked
        ? usersList.map(({ name, uuid: id, uid, avatar, email }) => ({
            name,
            id,
            uid,
            avatar,
            email,
          }))
        : [],
    }));
  };

  useEffect(() => {
    if (usersList.length === 0) return;
    let selectedUser = selectedUserGroup[USER_TAB_TYPE];
    let checked = usersList.every((e) =>
      selectedUser.some((i) => i.id === e.uuid)
    );
    setApplyToAllUser(checked);
  }, [selectedUserGroup, usersList]);

  const navTabData = [
    {
      id: 1,
      title: "Users",
      key: USER_TAB_TYPE,
    },
    {
      id: 2,
      title: "Groups",
      content: null,
      key: GROUP_TAB_TYPE,
    },
  ];

  const handleSelectAllGroupChildren = ({ group }) => {
    let currentGroup = { name: group.name, id: group.id, avatar: group.avatar };
    let selectedChildren = group.children.map((e) => ({
      name: e.name,
      id: e.id,
      avatar: e.avatar,
    }));
    let allGroups = [
      ...selectedChildren,
      ...selectedUserGroup[GROUP_TAB_TYPE],
      currentGroup,
    ];
    let uniqueGroups = removeDuplicatesByKey(allGroups, "id");
    setSelectedUserGroup((pre) => ({
      ...pre,
      [GROUP_TAB_TYPE]: uniqueGroups,
    }));
  };

  const handleUnSelectAllGroupChildren = ({ group }) => {
    let currentGroup = { name: group.name, id: group.id, avatar: group.avatar };
    let selectedChildren = group.children.map((e) => ({
      name: e.name,
      id: e.id,
      avatar: e.avatar,
    }));
    let allGroups = [...selectedChildren, currentGroup];
    let uniqueGroups = removeDuplicatesByKey(allGroups, "id");
    let alreadySelectedGroup = selectedUserGroup[GROUP_TAB_TYPE];

    setSelectedUserGroup((pre) => ({
      ...pre,
      [GROUP_TAB_TYPE]: removeMatchedDataUsingKey(
        alreadySelectedGroup,
        uniqueGroups,
        "id"
      ),
    }));
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case USER_TAB_TYPE:
        return (
          <UserList
            loading={loading}
            usersList={usersList}
            selectedUserGroup={selectedUserGroup}
            handleCheckboxChange={handleCheckboxChange}
          />
        );
      case GROUP_TAB_TYPE:
        return (
          <GroupList
            search={search}
            selectedUserGroup={selectedUserGroup}
            handleCheckboxChange={handleCheckboxChange}
            assign={assign}
            groupHierarchy={groupHierarchy}
            handleSelectAllGroupChildren={handleSelectAllGroupChildren}
            handleUnSelectAllGroupChildren={handleUnSelectAllGroupChildren}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="assignmodal p-3">
      <h6>
        Application:{" "}
        {[...selectedResource.application].length === 1
          ? selectedResource.application[0].name
          : `${selectedResource.application.length} application selected`}{" "}
      </h6>
      <h6>
        Module:{" "}
        {[...selectedResource.module].length === 1
          ? selectedResource.module[0].name
          : `${selectedResource.module.length} resource selected`}{" "}
      </h6>
      <div className="">
        <div className="searchwithborder seacrh-padding">
          <SearchBar
            onClick={() => {}}
            placeholder="Search..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      <TabNavigator
        tabs={navTabData}
        defaultActiveKey={activeTab}
        nav_wrapper_class="with-search"
        setActiveTab={setActiveTab}
      >
        {/* {activeTab === USER_TAB_TYPE && usersList.length > 0 && (
          <div className="text-detail" onClick={() => handleSelectAllUser({ target: { checked: !applyToAllUser } })}>
            <p className="m-0"> Available for everyone</p>
            <SimCheckBox checked={applyToAllUser} onChange={(e) => handleSelectAllUser(e)} />
          </div>
        )} */}
      </TabNavigator>

      {renderTabContent()}

      <br />

      <div className="modal-footer  justify-content-end p-0">
        <div className="modal-footer-btns gap-2">
          <button onClick={handleCancelModal} className="cancel">
            Cancel
          </button>
          <button onClick={handleVerifyModalShow} className="save">
            Assign
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShareModal;

export const UserAvatar = ({ user }) => {
  const [imageError, setImageError] = useState(false);
  return (
    <>
      {!imageError && user.avatar ? (
        <div className="thumnail">
          <img
            className="smallavatar"
            src={user.avatar}
            alt={user.name}
            onError={() => setImageError(true)}
            referrerPolicy="no-referrer"
          />
        </div>
      ) : (
        <span className="avatar-fallback">{getPlaceholderName(user.name)}</span>
      )}
    </>
  );
};

export const UserList = ({
  loading,
  usersList,
  selectedUserGroup,
  handleCheckboxChange,
}) => {
  return (
    <>
      {loading ? (
        <SkeltonResourceManage
          count="5"
          width="50px"
          height="50px"
          circle={true}
        />
      ) : (
        <div className="sharemodalcont">
          {usersList.map((user) => (
            <div
              className="d-flex justify-content-between user-card"
              key={user.uuid}
            >
              <div className="d-flex align-items-center gap-2">
                <SimCheckBox
                  id={`checkbox-${user.uuid}`}
                  checked={selectedUserGroup[USER_TAB_TYPE].some(
                    (e) => e.id === user.uuid
                  )}
                  onChange={() => handleCheckboxChange(user, USER_TAB_TYPE)}
                />
                <UserAvatar user={user} />
                <div>
                  <h6 className="username m-0">{user.name}</h6>
                  <p className="usermail m-0">{user.email || user.uid}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export const GroupList = ({
  search,
  selectedUserGroup,
  handleCheckboxChange,
  assign,
  groupHierarchy,
  handleSelectAllGroupChildren,
  handleUnSelectAllGroupChildren,
}) => {
  return (
    <>
      {search.length > 0 ? (
        <div className="sharemodalcont">
          {groupHierarchy?.list?.map((group) => {
            if (!group.name.toLowerCase().includes(search?.toLowerCase()))
              return null;
            return (
              <div
                className="d-flex justify-content-between pt-2"
                key={group.uuid}
              >
                <div className="d-flex align-items-center gap-2">
                  <SimCheckBox
                    id={`checkbox-${group.uuid}`}
                    checked={selectedUserGroup[GROUP_TAB_TYPE].some(
                      (e) => e.id === group.uuid
                    )}
                    onChange={() => handleCheckboxChange(group, GROUP_TAB_TYPE)}
                  />
                  <UserAvatar user={group} />
                  <div>
                    <h6 className="username m-0">{group.name}</h6>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="sharemodalcont grouphirarchy">
          <div className="pt-2 w-100">
            {renderGroups(
              groupHierarchy.hierarchy,
              selectedUserGroup,
              handleCheckboxChange,
              assign,
              handleSelectAllGroupChildren,
              handleUnSelectAllGroupChildren
            )}
          </div>
        </div>
      )}
    </>
  );
};

function checkListIdsInSelected(selected, list) {
  return list.every((listItem) =>
    selected.some((selectedItem) => selectedItem.id === listItem.id)
  );
}

export const renderGroups = (
  groupList,
  selectedUserGroup,
  handleCheckboxChange,
  assign,
  handleSelectAllGroupChildren,
  handleUnSelectAllGroupChildren
) => {
  return groupList.map((group) => {
    let allChildren = group?.children.map((e) => ({ id: e.id }));
    let haveChildren = allChildren.length > 0 ? true : false;
    return (
      <SimAccordion
        key={group.id}
        checkbox={
          <SimCheckBox
            checked={selectedUserGroup[GROUP_TAB_TYPE].some(
              (e) => e.id === group.id
            )}
            onChange={() =>
              handleCheckboxChange(
                { name: group.name, uuid: group.id, avatar: group.avatar },
                GROUP_TAB_TYPE
              )
            }
          />
        }
        button={
          haveChildren ? (
            <>
              {checkListIdsInSelected(selectedUserGroup[GROUP_TAB_TYPE], [
                ...allChildren,
                { id: group.id },
              ]) ? (
                <button
                  className="roundednormalbtn"
                  onClick={() => handleUnSelectAllGroupChildren({ group })}
                >
                  Unselect all
                </button>
              ) : (
                <button
                  className="roundednormalbtn"
                  onClick={() => handleSelectAllGroupChildren({ group })}
                >
                  Select all
                </button>
              )}
            </>
          ) : null
        }
        avatar={group.avatar}
        haveMoreDropdown={haveChildren}
      >
        <div heading={group.name}>
          {group.children &&
            renderGroups(
              group.children,
              selectedUserGroup,
              handleCheckboxChange,
              assign,
              handleSelectAllGroupChildren,
              handleUnSelectAllGroupChildren
            )}
        </div>
      </SimAccordion>
    );
  });
};
